import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var NextArrow = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 13",
    height: "1em",
    display: "inline-block",
    fill: "#ffffff",
    style: {
      margin: '0 4px',
      padding: '7px 0 0'
    },
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.113 7.312l-4.475 4.301a.79.79 0 000 1.149.87.87 0 001.196 0l5.918-5.688a.79.79 0 000-1.148L24.834.238A.86.86 0 0024.236 0a.86.86 0 00-.598.238.79.79 0 000 1.149l4.476 4.3H.845C.379 5.687 0 6.051 0 6.5c0 .449.379.812.845.812z"
  }));
});
NextArrow.displayName = 'NextArrow';

export { NextArrow, NextArrow as default };
